'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCamera = function IoCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 11.5c1.5 0 2.7 1.1 2.7 2.6v15.7c0 1.5-1.2 2.7-2.7 2.7h-27.1c-1.5 0-2.7-1.2-2.7-2.7v-15.7c0-1.5 1.2-2.6 2.7-2.6h5.3l3.1-3.1c0.5-0.6 1.2-0.9 1.9-0.9h6.6c0.7 0 1.3 0.3 1.8 0.8l3.2 3.2h5.2z m-13.5 17.1c3.9 0 7.1-3.3 7.1-7.3s-3.2-7.2-7.1-7.2-7.2 3.2-7.2 7.2 3.2 7.3 7.2 7.3z m13.1-13c0.6 0 1.1-0.4 1.1-1.1s-0.5-1.1-1.1-1.1-1.1 0.5-1.1 1.1 0.5 1.1 1.1 1.1z m-13.1 0.3c2.9 0 5.4 2.4 5.4 5.4s-2.5 5.5-5.4 5.5c-3.1 0-5.5-2.4-5.5-5.5s2.4-5.4 5.5-5.4z' })
        )
    );
};

exports.default = IoCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/camera.js
// module id = 2209
// module chunks = 0